import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login'; // Angenommen, du hast eine Login-Komponente
import MainPage from './pages/MainPage';
import './App.css';
import ForgetPassword from './pages/ForgetPasswordPage';
import ChangePassword from './pages/ChangePasswordPage';

function App() {
  const [loggedState, setLoggedState] = useState<number>(0);
  const [tag, setTag] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [token, setToken] = useState<string>('');

  document.title = "RescueInfo";

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="*" element={<Login setloggedState={setLoggedState}  setTag={setTag} setName={setName} setToken={setToken}/>} />
          <Route path="/ForgetPassword" element={<ForgetPassword />} />
          <Route path="/MainPage" element={<MainPage tag={tag} name={name} token={token} loggedState={loggedState} setloggedState={setLoggedState} />} />
          <Route path="/ChangePassword" element={<ChangePassword tag={tag}/>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;

